import { defineModule } from '@/js/utils/helpers';

const getElements = () => ({
  dialogs: document.querySelectorAll<HTMLDialogElement>(
    '.content-block--timeline dialog:has(+button)',
  ),
  buttons: document.querySelectorAll<HTMLButtonElement>(
    '.content-block--timeline dialog+button',
  ),
});

const onDialogButtonClick = (e: MouseEvent) => {
  const dialog = (e.target as HTMLElement)
    .previousElementSibling as HTMLDialogElement | null;
  if (!dialog || dialog.nodeName !== 'DIALOG') return;

  dialog.showModal();
};

const onDialogClick = (e: MouseEvent) => {
  const dialog = e.currentTarget as HTMLDialogElement;
  if (e.target === dialog || (e.target as HTMLElement).closest('a'))
    dialog.close();
};

export default defineModule(
  () => {
    const { buttons, dialogs } = getElements();

    buttons.forEach((btn) =>
      btn.addEventListener('click', onDialogButtonClick),
    );
    dialogs.forEach((dialog) =>
      dialog.addEventListener('click', onDialogClick),
    );
  },
  () => {
    const { buttons, dialogs } = getElements();

    buttons.forEach((btn) =>
      btn.removeEventListener('click', onDialogButtonClick),
    );
    dialogs.forEach((dialog) => {
      dialog.removeEventListener('click', onDialogClick);
      dialog.close();
    });
  },
);
